
import axios from 'axios'

import BaseService from './BaseService'
const Environment = require('../environments/environment.json')

const getFilteredExternalUsers = (exclusionList, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.post(`${Environment.apiUrl}/Users/GetFilteredExternalUsers`, exclusionList, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const addExternalUser = (externalUser, sessionKey) =>
{
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.post(`${Environment.apiUrl}/Users/AddExternalUser`, externalUser, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const getFilteredDealerUsers = (exclusionList, dealerId, sessionKey) =>
{
	const filterParams =
	{
		excludedUserIds: exclusionList,
		dealerId: dealerId
	}
	
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.post(`${Environment.apiUrl}/Users/GetFilteredDealerUsers`, filterParams, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const UsersService =
{
	getFilteredExternalUsers,
	addExternalUser,
	getFilteredDealerUsers
}

export default UsersService
